import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth";
import ApiPath from "./ConstantApi";
import { ReviewAndRatingResponce } from "./../Helpers/Interfaces/ReviewAndRatingType";
import Config from "../Config";

export interface RequestParams {
  productId: string;
}

export interface RequestParams {
  productId: string;
  page: number;
  pageSize: number;
}

export interface ReviewAndRatingRequest {
  productid: string;
  orderNumber: string;
  score: string;
  content: string;
  authorName: string;
}

// Converts JSON strings to/from your types
export class Convert {
  public static toMyOrderResponseModel(json: string): ReviewAndRatingRequest {
    return JSON.parse(json);
  }

  public static myOrderResponseModelToJson(
    value: ReviewAndRatingRequest,
  ): string {
    return JSON.stringify(value);
  }
}

export const RatingAndReviewService = createApi({
  reducerPath: "RatingAndReviewService",
  baseQuery: RtkBaseQueryWithReauth(Config.BASE_URL),
  tagTypes: ["Rating"],
  endpoints: (builder) => ({
    getReviewAndRating: builder.query<ReviewAndRatingResponce, RequestParams>({
      query: ({ productId, page, pageSize }) => ({
        url: `${ApiPath.getReviewAndRating}?productid=${productId}&page=${page}&pageSize=${pageSize}`,
        method: "GET",
      }),
      providesTags: ["Rating"],
    }),

    createReviewAndRating: builder.mutation<
      ReviewAndRatingResponce,
      ReviewAndRatingRequest
    >({
      query: (body) => ({
        url: `${ApiPath.createReview}`,
        method: "POST",
        body: body,
      }),
      transformResponse: (response: { data: ReviewAndRatingResponce }) =>
        response.data,
      invalidatesTags: ["Rating"],
    }),

    updateReviewAndRating: builder.mutation<
      ReviewAndRatingResponce,
      ReviewAndRatingRequest
    >({
      query: (body) => {
        return {
          url: `${ApiPath.updateReview}/${body.productid}`,
          method: "PUT",
          body: body,
        };
      },
    }),
  }),
});

export const {
  useLazyGetReviewAndRatingQuery,
  useCreateReviewAndRatingMutation,
  useUpdateReviewAndRatingMutation,
} = RatingAndReviewService;
